import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import fileDownload from 'js-file-download';

export default class ImageDownload extends React.Component {
  handleImageDownload = () => {
    const { id, plotUrl } = this.props;
    axios.get(plotUrl, { responseType: 'arraybuffer' }).then((response) => {
      fileDownload(response.data, `image-${id}.png`);
    });
  }

  render() {
    return (
      <button className="btn btn-primary" onClick={this.handleImageDownload}>Download Image</button>
    );
  }
}

ImageDownload.propTypes = {
  id: PropTypes.string.isRequired,
  plotUrl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ImageDownload.jsx